import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

const TONES = {
  green: "bg-emerald-50 text-emerald-700",
  blue: "bg-blue-50 text-blue-700",
  amber: "bg-amber-50 text-amber-700",
  slate: "bg-slate-100 text-slate-700",
};

export function Delta({ cur, prev }) {
  const d = cur - prev;
  const Icon = d > 0 ? ArrowUpRight : d < 0 ? ArrowDownRight : Minus;
  const cls = d > 0 ? "text-emerald-700 bg-emerald-50" : d < 0 ? "text-red-600 bg-red-50" : "text-slate-500 bg-slate-100";
  return (
    <span className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold ${cls}`}>
      <Icon className="w-3 h-3" />{d > 0 ? `+${d}` : d}
    </span>
  );
}

export function StatCard({ icon: Icon, label, value, hint, tone = "green", testId, delay = 0 }) {
  return (
    <div data-testid={testId} style={{ animationDelay: `${delay}ms` }}
      className="animate-rise bg-white rounded-2xl border border-slate-200/80 p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_-16px_rgba(15,23,42,0.12)] hover:shadow-[0_12px_28px_-14px_rgba(15,23,42,0.18)] hover:-translate-y-0.5 transition-[box-shadow,transform] duration-200">
      <div className="flex items-start justify-between gap-3">
        <div className="text-xs font-semibold text-slate-500">{label}</div>
        <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${TONES[tone]}`}><Icon className="w-[18px] h-[18px]" /></div>
      </div>
      <div data-testid={`${testId}-value`} className="text-3xl font-bold text-slate-900 tracking-tight mt-2" style={{ fontFamily: "Outfit, sans-serif" }}>{value}</div>
      <div className="text-xs text-slate-500 mt-2 flex items-center gap-1.5 min-h-[20px]">{hint}</div>
    </div>
  );
}
